export enum OnboardingPermissions {
    None = 0,
    OnboardingAdmin = 1 << 0
}